module.exports = __webpack_public_path__ + "img/login-btn.489e7fe1.png";